<div class="ui-showcase">
  <div class="showcase-header">
    <h1>UI Components Showcase</h1>
    <select-input-field
      label="variant"
      [control]="variantControl"
      [options]="selectVariantOptions"
      [variant]="variant"
      (changed)="onVariantChange($event)"
    />
    <label class="disabled-toggle" for="disabledToggle">
      <span>Disabled</span>
      <p-toggleswitch inputId="disabledToggle" [(ngModel)]="isDisabled" (ngModelChange)="onDisabledToggleChange($event)" />
    </label>
  </div>

  <section class="showcase-section">
    <h2>Map</h2>
    <div class="showcase-item showcase-item__map">
      <completion-map class="showcase-item__map--content" ariaLabel="PPFP task locations" [points]="mapPoints" [options]="mapOptions" />
    </div>
  </section>

  <section class="showcase-section">
    <h2>Text Input Field</h2>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Default</h3>
      <input-field label="Name" [control]="textControl" [variant]="variant" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>With prefix icon</h3>
      <input-field label="Search" [control]="textControl" [variant]="variant" prefixIcon="pi-search" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>With English flag prefix</h3>
      <input-field label="English value" [control]="textControl" [variant]="variant" prefixIcon="en" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>With Norwegian flag prefix</h3>
      <input-field label="Norwegian value" [control]="textControl" [variant]="variant" prefixIcon="nb" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Number type</h3>
      <input-field label="Amount" type="number" [control]="numberControl" [variant]="variant" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>With error</h3>
      <input-field label="Required field" [control]="textWithErrorControl" [variant]="variant" errorMessage="This field is required" />
    </div>
  </section>

  <section class="showcase-section">
    <h2>Date Input Field</h2>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Default</h3>
      <date-input-field label="Start date" [control]="dateControl" [variant]="variant" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Datetime</h3>
      <datetime-input-field label="Start date" [control]="datetimeControl" [variant]="variant" />
    </div>
  </section>

  <section class="showcase-section">
    <h2>Autocomplete Field</h2>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <autocomplete label="Name" [control]="autocompleteControl" [variant]="variant" />
    </div>
    <h2>Select Input Field</h2>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Default</h3>
      <select-input-field label="Choose option" [control]="selectControl" [options]="selectOptions" [variant]="variant" />
    </div>
  </section>

  <section class="showcase-section">
    <h2>Multi Select</h2>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Default</h3>
      <multi-select label="Choose options" [control]="multiSelectControl" [options]="selectOptions" [variant]="variant" />
    </div>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>As checkbox list</h3>
      <multi-select
        label="Choose options"
        [control]="multiSelectControl"
        [options]="selectOptions"
        [displayAsCheckboxList]="true"
        [variant]="variant"
      />
    </div>
  </section>

  <section class="showcase-section">
    <h2>Add Button</h2>
    <div class="showcase-item" [class.showcase-item__over]="variant === 'over'">
      <h3>Default</h3>
      <add-button label="Add item" icon="pi pi-plus" ariaLabel="Add new item" (clicked)="onAddButtonClick()" />
    </div>
  </section>

  <section class="showcase-section">
    <h2>Tabs</h2>
    <div class="showcase-item">
      <ui-tabs [(value)]="activeTab">
        <ng-template uiTabPanel [uiTabPanel]="0" label="Overview">
          <p>Overview tab content</p>
        </ng-template>
        <ng-template uiTabPanel [uiTabPanel]="1" label="Details" [lazy]="true">
          <p>Lazy-loaded details tab content</p>
        </ng-template>
      </ui-tabs>
    </div>
  </section>
</div>
